import { REGISTER } from 'src/Actions/Registration/types';

export const initialState = {
  accountStatus: null,
  accountStatusError: null,
  fieldValue: {},
  formError: {},
  accreditingIdOptions: []
};

const registerReducer = (state = initialState, action = {}) => {
  //NOSONAR
  switch (action.type) {
    case REGISTER.GET_FACILITIES:
    case REGISTER.GET_ACCOUNT_STATUS: {
      return {
        ...state,
      };
    }

    case REGISTER.GET_ACCOUNT_STATUS_SUCCESS: {
      let { accountStatus } = action;
      let formattedAccrediting = accountStatus.userAccountSetup?.accreditingTypesList?.map((item) => {
        return {
            value: item,
            label: item
        }
    });
      return {
        ...state,
        accountStatus,
        fieldValue: accountStatus.userAccountSetup,
        accreditingIdOptions: formattedAccrediting ? formattedAccrediting : []
      };
    }
    case REGISTER.GET_ACCOUNT_STATUS_FAILURE: {
      let { error } = action;
      return {
        ...state,
        accountStatusError: error,
      };
    }
    case REGISTER.UPDATE_ERROR: {
      const { errorValue } = action;
      return {
        ...state,
        formError: setFormError(state.formError, errorValue),
        // isErrorDisplay: setErrorDisplay(state.formError),
      };
    }
    case REGISTER.UPDATE_FIELD_VALUE: {
      const { fieldValue: newValue } = action;
      return {
        ...state,
        fieldValue: { ...state.fieldValue, ...newValue },
      };
    }
    case REGISTER.UPDATE_ACCOUNT_STATUS: {
      let { accountStatus } = action;
      return {
        ...state,
        accountStatus,
      };
    }
    case REGISTER.UPDATE_ADMIN_TERMS: {
      let { tncCheck } = action;
      return {
        ...state,
        updateRequest: tncCheck,
      };
    }
    case REGISTER.UPDATE_ADMIN_TERMS_SUCCESS: {
      let { response } = action;
      return {
        ...state,
        updateDetails: response,
      };
    }
    case REGISTER.UPDATE_ADMIN_TERMS_FAILURE: {
      let { error } = action;
      return {
        ...state,
        updateDetailsErr: error,
      };
    }

    case REGISTER.GET_FACILITIES_SUCCESS: {
      let { facilities } = action;

      return {
        ...state,
        facilities,
      };
    }
    case REGISTER.GET_FACILITIES_FAILURE: {
      let { error } = action;
      return {
        ...state,
        facilitiesError: error,
      };
    }

    default:
      return state;
  }
};

const setFormError = (formError, errorObj) => {
  for (let i in errorObj) {
    if (errorObj[i] === '') {
      if (formError[i]) delete formError[i];
    } else {
      formError = { ...formError, ...errorObj };
    }
  }
  return formError;
};
export default registerReducer;
